import createStep1Content from "./elements/create-step-1-content";
import createCard from "./elements/create-card";
import { customEvent, generateLeadEvent } from "../../modules/tracking/AnalyticsEvents";
require('../../modules/polyfills/remove');

export default class {
    constructor(options) {
        this.liveChatOpen = false;
        this.card = false;
        this.cardContent = false;
        this.currentStep = '';
        this.brand = '';
        if (typeof brand !== 'undefined' && brand !== '') {
            this.brand = brand;
        }
        this.specificDealer = false;
        this.name = '';
        // setTimeout handler
        this.replaceCardContentTimeout = false;
        this.quickAnimation = false;

        // Bodyscroll lock is needed for iOS modal as it scrolls the background instead of the modal
        this.bodyScrollLock = false;

        // SDEs are data objects used by LivePerson to help qualify the lead
        this.vehicleSdes = [];
        this.customerSdes = {
            "type": "ctmrinfo",
            "info": {
                "ctype": '',
                "storeNumber": '',
                "storeZipCode": null,
                "companyBranch": '',
            },
        };

        // If the body element has data-activity-type, use it to set the customer SDE type
        if (document.body.dataset.activityType) {
            let activityData = document.body.dataset.activityType;
            this.setCustomerType(((activityData) ? activityData : 'Unknown'));
        }

        this.redesign = false;
        if (typeof options != 'undefined') {
            if (typeof options.redesign != 'undefined' && options.redesign == true) {
                this.redesign = true;
            }
        }

        this.getActiveLivePersonTag().then(data => {
            // Event to determine when an active live chat is closed
            lpTag.events.bind({
                eventName : "windowClosed",
                appName : "lpUnifiedWindow",
                func: function() {
                    this.liveChatOpen = false;
                },
                context: this,
                async: true,
                triggerOnce : false
            });

            // Add a state change event to hide the live chat card when a live chat window is already open on page load
            lpTag.events.bind({
                eventName : "state",
                appName : "lpUnifiedWindow",
                func: function(event) {
                    const state = event.state || '';
                    if (state == 'init') {
                        this.liveChatOpen = true;
                        this.currentStep = 'live chat maybe open';
                        this.removeCard();
                    }
                },
                context: this,
                async: true,
                triggerOnce : false
            });
        })

        window.addEventListener("hashchange", (event) => {
            const hash = location.hash.substring(1);
            if (hash == 'live-chat') {
                this.quickAnimation = true;
                this.openLiveChat();
            }
        });

        const hash = location.hash.substring(1);
        if (hash == 'live-chat') {
            this.quickAnimation = true;
            this.openLiveChat();
        }
    }

    /**
     * Get the engagement info from the lpTag if possible, if not return null
     */
    getEngagementInfo() {
        if (typeof lpTag == 'undefined') {
            return;
        }
        if (typeof lpTag.taglets == 'undefined') {
            return;
        }
        if (typeof lpTag.taglets.rendererStub == 'undefined') {
            return;
        }
        if (typeof lpTag.taglets.rendererStub.getEngagementInfo == 'undefined') {
            return;
        }

        const engagementInfo = lpTag.taglets.rendererStub.getEngagementInfo(2295820350);
        if (!engagementInfo) {
            return;
        }
        if (typeof engagementInfo.engagementId == 'undefined') {
            return;
        }

        return engagementInfo;
    }

    /**
     * async method that resolves with the engagement info when it's finally available
     * avoid calling this multiple times as it will spawn a new interval process in the background each time
     */
    async getActiveLivePersonTag() {
        return new Promise((resolve, reject) => {
            const engagementInfo = this.getEngagementInfo();
            if (engagementInfo) {
                resolve(engagementInfo);
                return;
            }

            const waitingForLpTagInterval = window.setInterval(() => {
                const engagementInfo = this.getEngagementInfo();
                if (engagementInfo) {
                    resolve(engagementInfo);
                    clearInterval(waitingForLpTagInterval);
                }
            }, 250);
        });
    }

    /**
     * Vehicle data used for the SDEs sent to LivePerson
     *
     * @param {Object} vehicleData
     */
    setVehicleData(vehicleData) {
        this.vehicleSdes = [
            {
                "type": "voi",
                "voi": {
                    "year": (vehicleData.year) ? vehicleData.year : null,
                    "make": (vehicleData.manufacturer) ? vehicleData.manufacturer : null,
                    "model": (vehicleData.model) ? vehicleData.model : null,
                    "vin": (vehicleData.reg_no) ? vehicleData.reg_no : null,
                    "stockType": (vehicleData.new_or_used && vehicleData.new_or_used == 'new') ? 'new' : 'used',
                    "stockNumber": (vehicleData.id) ? vehicleData.id : null,
                    "trim": (vehicleData.trim) ? vehicleData.trim : null,
                }
            },
            {
                "type": "lead",
                "lead": {
                    "topic": (vehicleData.title) ? vehicleData.title : null,
                    "value": (vehicleData.price) ? vehicleData.price : null,
                    "currency": (vehicleData.fuel_type) ? vehicleData.fuel_type : null,
                }
            },
        ];
    }

    /**
     * Customer data used for the SDEs sent to LivePerson
     *
     * @param {Object} vehicleData
     */
    setCustomerData(customerData) {
        this.customerSdes = {
            "type": "ctmrinfo",
            "info": {
                "ctype": (customerData.type) ? customerData.type : "Unknown",
                "storeNumber": '' + ((customerData.location_id) ? customerData.location_id : ""),
                "storeZipCode": (customerData.postcode) ? customerData.postcode : null,
                "companyBranch": (customerData.brand) ? customerData.brand : null,
            },
        };
    }

    /**
     * Customer type to be sent in SDEs to LivePerson
     *
     * @param {String} vehicleData
     */
    setCustomerType(type) {
        this.customerSdes.info.ctype = type;
    }

    /**
     * Customer postcode to be sent in SDEs to LivePerson
     *
     * @param {String} vehicleData
     */
    setCustomerPostcode(postcode) {
        this.customerSdes.storeZipCode = postcode;
    }

    /**
     * Create the basic card HTML
     */
    createCard() {
        if (this.card !== false) {
            return;
        }
        const card = createCard(this);
        this.card = card.card;
        this.cardContent = card.content;
    }

    /**
     * Remove the card HTML
     */
    removeCard() {
        if (this.card === false) {
            return;
        }
        this.card.remove();
        this.card = false;
        this.cardContent = false;
        this.currentStep = '';
        this.liveChatOpen = false;
        // Remove the #live-chat hash when removing the card
        const hash = location.hash.substring(1);
        if (hash == 'live-chat') {
            location.hash = '';
        }
    }

    /**
     * Add a loader to the card
     */
    setLoading() {
        // const loadingContainer = document.createElement('div');
        // loadingContainer.classList.add('loading');
        // const loadingImage = document.createElement('img');
        // loadingImage.setAttribute('src', '/images/shared/Robins-And-Day-Loader.svg');
        // loadingImage.setAttribute('alt', 'Starting Chat');
        // loadingContainer.appendChild(loadingImage);
        // this.card.appendChild(loadingContainer);
        this.card.classList.add('live-chat-card--loading');
    }

    /**
     * Used to trigger live chat depending on the page type
     */
    openLiveChat() {
        this.createCard();
        if (this.liveChatOpen) {
            if (this.currentStep == 'specific_dealer') {
                if (typeof window.liveChatLocationId !== 'undefined' && window.liveChatLocationId != '') {
                    // this.initLiveChat(window.liveChatLocationId);
                    this.startChat({
                        id: window.liveChatLocationId,
                    });
                    customEvent('Live Chat', 'Start Chat', 'Opened from link on page');
                    return;
                }
                this.startChat(null);
            }
            return;
        }

        if (typeof window.liveChatLocationId !== 'undefined' && window.liveChatLocationId != '') {
            // this.initLiveChat(window.liveChatLocationId);
            this.startChat({
                id: window.liveChatLocationId,
            });
            customEvent('Live Chat', 'Start Chat', 'Opened from link on page');
            return;
        }

        this.startChat(null);
    }

    /**
     * Show the live chat drop in card.
     * If the card is already showing in the same state, this will do nothing.
     * If there is already an active live chat conversation, this will do nothing
     *
     * @param {int} locationId (optional) The location.id of the dealer to use
     */
    async initLiveChat(locationId = false) {
        if (this.liveChatOpen) {
            return;
        }
        this.liveChatOpen = true;
        // If there's a valid dealer that can be set, render that card, or failing that render the standard multi dealer card
        this.setDealer(locationId)
        .then(() => {
            // Blank the name and image in case any are set from a previous dealer
            this.name = '';
            this.image = '/images/live-chat/default-agent@2x.jpg';
            // Create the HTML
            this.createCard(this);

            this.step('specific_dealer');
        })
        .catch(() => {
            this.createCard(this);
            this.step('specific_dealer');
        });
    }

    /**
     * Use a specific dealer rather than the multi-brand version
     * @param {String} dealer
     */
    async setDealer(locationId = false) {
        return new Promise(async (resolve, reject) => {
            if (!locationId) {
                this.specificDealer = false;
                reject();
                return;
            }

            if (locationId == 'aftersales') {
                this.specificDealer = {
                    name: 'Aftersales',
                    live_chat_enabled: 1,
                    id: 0,
                };
                resolve(this.specificDealer);
                return;
            }

            // Go through the global location data and find the record for this dealer
            let specificDealer = false;
            const locationData = await window.LocationDataLoader.get();
            locationData.forEach(dealer => {
                if (dealer.id == locationId) {
                    specificDealer = dealer;
                }
            });
            if (!specificDealer) {
                console.error("Dealer couldn't be found for ID", locationId);
                reject();
                return;
            }

            this.specificDealer = specificDealer;

            resolve(this.specificDealer);
            return
        })
    }

    /**
     * Blanks the content area of the card
     */
    resetCardContent() {
        while (this.cardContent.firstChild) {
            this.cardContent.removeChild(this.cardContent.firstChild);
        }
    }

    /**
     * Blanks the content area of the card
     * @param {Node} nodeToAppend The new content to put in the card
     * @param {String} classToAppend (optional) Add a new class to the container element
     */
    replaceCardContent(nodeToAppend, classToAppend = '') {
        return new Promise((resolve, reject) => {
            // Clear any unfinished timeouts
            if (this.replaceCardContentTimeout) {
                clearTimeout(this.replaceCardContentTimeout);
            }

            // Remove any previous classes
            let classesToRemove = [];
            this.card.classList.forEach(classListItem => {
                if (classListItem != 'live-chat-card') {
                    classesToRemove.push(classListItem);
                }
            });

            classesToRemove.forEach(itemToRemove => {
                this.card.classList.remove(itemToRemove);
            });

            if (classToAppend != '') {
                this.card.classList.add(classToAppend);
            }

            // If there's a child node, animate changing state
            if (this.cardContent.firstChild) {
                this.cardContent.classList.add('live-chat-card__content-container--fade-out');
                this.cardContent.classList.add('live-chat-card__content-container--fade-out');
                this.replaceCardContentTimeout = setTimeout(() => {
                    this.resetCardContent();
                    this.cardContent.appendChild(nodeToAppend);
                    this.cardContent.classList.remove('live-chat-card__content-container--fade-out');
                    resolve();
                }, 250);
                return;
            }

            // Otherwise instantly pop the content in as it's probably the first load and doesn't need fading in
            this.cardContent.appendChild(nodeToAppend);
            resolve();
        });
    }

    /**
     * Jump to a specific step
     * @param {Int} stepNumber
     */
    step(stepNumber) {
        // This step changes the card so it's dedicated to a single dealer and the customer can only select chat or text
        if (stepNumber == 'specific_dealer') {
            const content = createStep1Content(() => {
                this.startChat(this.specificDealer);
                customEvent('Live Chat', 'Start Chat - Dealer Card', 'Clicked');
            });

            this.replaceCardContent(content, 'live-chat-card__step-1')
            .then(() => {});

            this.currentStep = stepNumber;
            return;
        }
    }

    /**
     * Start the chat window
     */
    async startChat(dealer = null) {
        this.setLoading();
        const waitForLpTagToBeReady = await this.getActiveLivePersonTag();
        if (!lpTag || !lpTag.taglets || !lpTag.taglets.rendererStub) {
            return;
        }

        let sdesToSend = [];
        lpTag.sdes = lpTag.sdes || [];

        if (dealer != null) {
            this.customerSdes.info.storeNumber = '' + (dealer.id || '');
            this.customerSdes.info.companyBranch = dealer.brand || '';
            sdesToSend.push(this.customerSdes);
        }

        if (this.vehicleSdes.length > 0) {
            sdesToSend.push(this.vehicleSdes[0]);
            sdesToSend.push(this.vehicleSdes[1]);
        }

        lpTag.sdes.send(sdesToSend);
        lpTag.taglets.rendererStub.click(2295820350);

        customEvent('Live Chat', 'Start Chat', 'LivePerson widget opened');
        generateLeadEvent('live_chat');

        this.liveChatOpen = true;
        this.currentStep = 'live chat maybe open';
        this.removeCard();
        return;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/live-chat/modules/live-chat-class.js